import React from 'react';
import { useStyles } from './chip.styles';
import { IconButton, TextField, Typography } from '@material-ui/core';
import { MinusCircleIcon } from '@room-match/shared-ui-components';
import { COLORS } from 'shared/constants/COLORS';

interface Props {
  unionName?: string;
  unionId: string;
  setUnionId?: (id: string) => void;
  removeUnion?: (id: string) => void;
}

const UnionChip: React.FC<Props> = ({ unionName, unionId, setUnionId, removeUnion }) => {
  const { chips, name: nameStyle, wrapper } = useStyles();
  const error = !unionName || !setUnionId || !removeUnion;

  if (error)
    return (
      <div
        className={chips}
        style={{
          border: `solid 1px ${error ? '#d83032' : 'transparent'}`,
        }}
      >
        {' '}
        Error
      </div>
    );
  return (
    <div
      className={chips}
      style={{
        border: `solid 1px ${error ? '#d83032' : 'transparent'}`,
        marginTop: 15,
      }}
    >
      {/* <StyledTooltip
        disableHoverListener={!required_access_code}
        title={'Click to enter the code provided by your agency in order to add representation with this company.'}
      > */}
      <div className={wrapper}>
        <Typography data-cy="union-name" className={nameStyle}>
          {unionName}
        </Typography>
        {/* {required_access_code ? (
          <IconButton disableRipple style={{ padding: 5, marginLeft: 'auto' }}>
            <CiLock fontSize={24} color={codeCorrect ? COLORS.SUCCESS : '#d83032'} />
          </IconButton>
        ) : (
          <React.Fragment />
        )} */}
        <IconButton
          data-cy="remove-chip"
          style={{ padding: 5, marginLeft: 5, marginRight: -5 }}
          onClick={(e) => {
            e.stopPropagation();
            removeUnion(unionId);
          }}
        >
          <MinusCircleIcon />
        </IconButton>
        {/* {showCodeModal && (
          <CodeModal
            showCodeModal={showCodeModal}
            close={() => setshowCodeModal(false)}
            agencyName={name}
            code={code}
            onSubmit={handleOnSubmit}
          />
        )} */}
      </div>
      {/* </StyledTooltip> */}

      {unionName !== 'NON UNION' ? (
        <TextField
          data-cy="union-id"
          placeholder={'Union ID'}
          variant="outlined"
          style={{ margin: 0, background: 'red !important', border: 'none' }}
          value={unionId}
          onChange={(e) => setUnionId(e.target.value)}
          InputProps={{
            style: {
              fontWeight: 800,
              background: COLORS.DARK_GRAY,
            },
          }}
        />
      ) : (
        <React.Fragment />
      )}
    </div>
  );
};

export default UnionChip;
